import { parse } from 'date-fns';

export default function getDocumentDate(d: string | null | undefined, fallbackDate?: string): Date | undefined {
	let pattern = "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'";
	let containsZ = true;
	if (!/\.\d{3}Z$/.test(d ?? "")) {
		pattern = "yyyy-MM-dd'T'HH:mm:ss'Z'";
	}
	if (!d?.endsWith("Z")) {
		pattern = pattern.substring(0, pattern.length - 3);
		containsZ = false
	}
	let _fallbackDate = fallbackDate;
	if (fallbackDate) {
		if (fallbackDate.endsWith("Z") && !containsZ) {
			_fallbackDate = _fallbackDate?.substring(0, _fallbackDate.length - 2);
		} else if (!fallbackDate.endsWith("Z") && containsZ) {
			_fallbackDate = _fallbackDate + "Z";
		}

	}

	if (d) {
		return parse(d ?? _fallbackDate, pattern, new Date());
	}
	return undefined;
}